export default __webpack_public_path__ + "static/media/icon-viewPosition-dark.4dbb3fb2.svg";